export const enum DATA_ANALYTICS_COMMON {
  PAGELOAD = 'page load',
  SYSTEMENVIRONMENT = 'responsive',
  ACCOUNTTYPE = 'accountType',
  ACCOUNT = 'account',
  DESKTOP = 'desktop',
  MOBILE = 'mobile'
}

export const AmexCardType: CardType[] = [
  {
    id: 'AXBG',
    value: 'gold'
  },
  {
    id: 'AXCG',
    value: 'gold'
  },

  {
    id: 'AXCP',
    value: 'platinum'
  },
  {
    id: 'AXBP',
    value: 'platinum'
  },
  {
    id: 'AXCV',
    value: 'reserve'
  },
  {
    id: 'AXBV',
    value: 'reserve'
  }
];

export interface CardType {
  id: string;
  value: string;
}

export const enum USER_LOGGED_IN_STATUS {
  AUTHENTICATED = 'authenticated',
  HOT = 'hot'
}